import * as React from 'react';

import { UitkFigure, UitkImage } from 'uitk-react-images';
import { UitkSheet } from 'uitk-react-sheet';

export interface MapSheetProps {
  title: string;
  subtitle?: string;
  description?: string;
  isVisible?: boolean;
  photoUrl?: string;
  photoAlt?: string;
}

export const MapSheet: React.SFC<MapSheetProps> = ({ title, subtitle, description, isVisible, photoUrl, photoAlt }) => {
  if (!title) {
    return null;
  }

  const containerClasses = [
    'uitk-cell',
    'all-cell-fill',
    'all-cell-1-2',
    'all-l-padding-three',
    'all-t-padding-three',
    'all-b-padding-three'
  ];

  return (
    <UitkSheet className="his-map-sheet uitk-grid" isVisible={isVisible}>
      <MapSheetImage photoUrl={photoUrl} photoAlt={photoAlt} />
      <div className={containerClasses.join(' ') + ' all-r-padding-three'}>
        <div className="uitk-grid">
          <div className="his-map-sheet__name uitk-cell uitk-type-400	uitk-type-bold">{title}</div>
          <div className="his-map-sheet__distance uitk-cell all-t-padding-half all-b-padding-one">{subtitle}</div>
          {description && <div className="his-map-sheet__distance uitk-cell all-t-padding-half all-b-padding-one">{description}</div>}
        </div>
      </div>
    </UitkSheet>
  );
};
MapSheet.displayName = 'MapSheet';

interface MapSheetImageModel {
  photoUrl?: string;
  photoAlt?: string;
}

export const MapSheetImage: React.FunctionComponent<MapSheetImageModel> = ({ photoUrl, photoAlt }) => {
  if (photoUrl) {
    return (
      <div className="uitk-cell all-cell-1-4">
        <UitkFigure className="his-map-sheet__image all-image-fit-cover">
          <UitkImage src={photoUrl} alt={photoAlt} />
        </UitkFigure>
      </div>
    );
  }

  return null;
};
MapSheetImage.displayName = 'MapSheetImage';
